var React = require('react');

function MobileNotificationIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 8c3.75 0 6.556 2.81 6.556 6v2.9c0 1.356.87 2.304 1.682 2.759.17.096.313.212.427.341H7.335c.114-.13.256-.245.427-.341.811-.455 1.682-1.403 1.682-2.758V14c0-3.19 2.807-6 6.556-6zm8.556 6c0-4.418-3.83-8-8.556-8-4.725 0-8.556 3.582-8.556 8v2.9c0 .432-.284.803-.66 1.014C5.715 18.514 5 19.607 5 20.857V21a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-.143c0-1.25-.715-2.343-1.784-2.943-.376-.21-.66-.582-.66-1.013V14zM15 24a1 1 0 1 0-2 0 3 3 0 1 0 6 0 1 1 0 1 0-2 0 1 1 0 1 1-2 0z","fill":"#fff"}));
}

MobileNotificationIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = MobileNotificationIcon;

MobileNotificationIcon.default = MobileNotificationIcon;
